<template>
  <v-card :loading="loading" class="transparent" flat>
    <v-card-title>
      <v-btn
        v-status="'role_create'"
        :to="{ name: 'roles.store' }"
        class="btn-add-with-text"
      >
        <v-icon>mdi-plus</v-icon>
        افزودن
      </v-btn>
    </v-card-title>
    <v-divider />

    <v-row class="pa-2" no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.length"
          :items="[10, 25, 50, 100, 200, 400]"
          dense
          hide-details
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="tableProps.search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="جستجو"
          outlined
          @keydown.enter="reloadTable()"
          @click:append="reloadTable()"
          @click:clear="clearFields"
        />
      </v-col>
    </v-row>

    <data-table
      :columns="columns"
      :data="data"
      :translate="translates"
      class="p-2"
      orderDir="desc"
    >
      <div slot="filters" />

      <div slot="pagination">
        <pagination
          v-if="data && data.data"
          ref="pagination"
          :data="data"
          @page="onPagination"
        >
          <template v-slot:per-page>
            <v-select
              v-model="tableProps.length"
              :items="[10, 25, 50, 100, 400]"
              :menu-props="{ offsetY: true }"
              class="ma-2 my-md-0"
              dense
              label="تعداد نمایش"
              outlined
              @change="onPerPage"
            />
          </template>
        </pagination>
      </div>
    </data-table>

    <v-dialog v-model="userdialog" max-width="800px" scrollable>
      <v-card :loading="loading" elevation="2" outlined>
        <v-card-title>
          لیست کاربران استفاده کننده از نقش
          {{ roleName }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-actions>
          <v-text-field
            v-model="tableProps.search"
            append-icon="mdi-magnify"
            class="my-3"
            hide-details
            label="جستجو"
          />
        </v-card-actions>

        <v-list style="background: white; z-index: 999">
          <v-list-item v-for="(x, i) in users.data" :key="i">
            <v-list-item-content>
              <v-list-item-title v-text="x.name + ' ' + x.lastName" />
              <v-list-item-subtitle v-text="x.username"> </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-actions
          class="justify-end"
          style="background: white; z-index: 999"
        >
          <hr />
          <v-spacer></v-spacer>

          <Paginate
            :links="users.links"
            :tableProps="tableProps"
            :total="users.last_page"
            @changePage="roleUsers(url, tableProps)"
          ></Paginate>

          <!--                <v-btn  outlined class="mr-auto btn-cancel" text @click="dialog = false, $emit('changeUserId', value = null)">-->
          <!--                  <v-icon>mdi-close-circle</v-icon>-->
          <!--                  <b>بستن</b>-->
          <!--                </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Paginate from "@/view/pages/admin/Messages/Paginate";
import Button from "@/view/pages/Button";
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import Pagination from "@/view/pages/pickers/pagination.vue";

export default {
  components: { Pagination, Paginate },
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      users: [],
      roleName: null,
      selectedRole: null,
      userdialog: false,
      item: null,
      url: "admin/roles",
      columns: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "نام",
          name: "name",
        },
        {
          label: "نام فارسی",
          name: "name_fa",
        },
        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "role_",
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                name: "show",
                label: "لیست کاربران",
                icon: "eye",
                class: "btn-show",
              },
            ],
          },
        },
      ],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
    };
  },

  mounted() {
    this.getConfigs(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  computed: {
    config() {
      return this.layoutConfig();
    },
  },

  methods: {
    roleUsers(url = this.url, props = this.tableProps) {
      this.loading = true;

      this.requestApiGet(url, props)
        .then(({ data }) => {
          this.loading = false;
          this.users = data;
        })
        .catch(({ response }) => this.$toast.error("خطا در دریافت اطلاعات"))
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.getConfigs();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      this.tableProps.page = 1;
      this.$nextTick(() => {
        this.reloadTable();
      });
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    reloadTable(tableProps) {
      this.tableProps.page = 1;
      this.$nextTick(() => {
        this.getConfigs(this.url, tableProps);
      });
    },
    getConfigs(url = this.url, query = this.tableProps) {
      this.loading = true;

      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {})
        .finally(() => (this.loading = false));
    },
    reload() {
      this.getConfigs(this.url, this.tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    show(data) {
      this.roleName = data.name;
      this.selectedRole = data.id;
      this.roleUsers(`admin/roleList/${this.selectedRole}`, this.tableProps);
      // this.item = data;
      this.userdialog = true;
    },
    edit(data) {
      this.$router.push({ name: "role.edit", params: { id: data.id } });
    },
    clearFields() {
      this.$nextTick(() => {
        this.reloadTable();
      });
    },
  },
};
</script>
